"use client"

import { useFormContext } from "react-hook-form"
import { SignupFormType } from "./types/signup.type"

export const useSignupFormContext = () => {
    const context = useFormContext<SignupFormType>() 
    if(!context) {
        throw new Error('useSignupFormContext must be used within React Hook Form Provider')
    }
    return context   
}